import React, {useState} from "react";

import {Autocomplete} from "@mui/material";
import TextField from "@mui/material/TextField";
import {Button} from "@mui/material";
import GroupBy from "./classes/view/GroupBy";


export const GroupByFormRow = ({view}) => {
    const colDefs = view.getAllColumnDefs();
    const groupBys = view.getPendingGroupBys();

    const [column, setColumn] = useState(null);
    const [chosen, setChosen] = useState(groupBys.map(g => g.column));

    if (view.getAppliedGroupBys().length === 0 && view.getPendingGroupBys().length === 0 && chosen.length > 0) {
        setChosen([]);
    }

    const options = colDefs.filter(col => !chosen.find(ch => ch.getIndex() === col.getIndex())).filter(col => col.isCategorical || col.isDate).map(col => {
        return {value: col.getIndex(), label: col.displayName};
    })


    return <div className="canold-table-view-menu-form-row" key={"canold-table-group-by-form-row-" + groupBys.length}>
        <Autocomplete
            className={"canold-table-column-view-form-dropdown group-by-form-dropdown"}
            key={"canold-table-column-view-form-dropdown-" + groupBys.length}
            filterSelectedOptions
            id={"canold-table-group-by-dropdown"}
            name={"canold-table-group-by-dropdown"}
            role={"canold-table-group-by-dropdown"}
            options={options}
            disablePortal={true}
            isOptionEqualToValue={(option, value) => {
                return option.value === value.value;
            }}
            onChange={(evt, option, reason) => {
                if (option && option.value !== null) {
                    const column = colDefs[option.value];
                    setColumn(column);
                } else {
                    setColumn(null);
                }
            }}
            onClick={(evt) => {
                evt.stopPropagation(); // Prevent event bubbling
            }}
            renderOption={(props, option) => {
                return <li {...props} key={"canold-table-group-by-dropdown-option-" + option.value + "-" + groupBys.length}>
                    {option.label}
                </li>
            }}
            renderInput={(params) => {
                return <TextField
                    {...params}
                    label=""
                    onClick={(evt) => {
                        evt.stopPropagation(); // Prevent event bubbling
                    }}
                    placeholder="Column Name"
                    role={"canold-table-group-by-dropdown-input"}
                    key={"canold-table-group-by-dropdown-input-" + groupBys.length}
                />
            }}

        />
        <Button
            className={"canold-table-add-group-by-button"}
            role={"canold-table-add-group-by-button"}
            variant="contained"
            disabled={column === null}
            onClick={() => {
                const stateChange = new GroupBy({column: column});
                view.addStateChange(stateChange);
                view.onPendingStateChange([stateChange]);
                setColumn(null);
                setChosen(prev => {
                    return [...prev, column];
                });
            }}
        >Add</Button>
    </div>
}


export default GroupByFormRow;